import React, { useEffect } from 'react'
import {
  resetCrossClientResults,
  setCrossClientResultsExecution,
  setCrossClientResultsExecutionLoading,
  setCrossClientTeammates,
} from '../../../store/crossClient/crossClientResults'
import { useLazyGetCrossClientQueryExecutionQuery } from '../../../store/crossClient/crossClient'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useLazyGetAllUsersQuery } from '../../../store/user/user'

export interface CrossClientResultsInitializationProps {
  executionId: string
}

export const CrossClientResultsInitialization: React.FC<CrossClientResultsInitializationProps> = ({ executionId }) => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)

  const [triggerGetCrossClientQueryExecution] = useLazyGetCrossClientQueryExecutionQuery()
  const [triggerGetAllUsers] = useLazyGetAllUsersQuery()

  useEffect(() => {
    const getExecution = async () => {
      try {
        dispatch(setCrossClientResultsExecutionLoading(true))
        const execution = await triggerGetCrossClientQueryExecution({ accountId, executionId, expand: ['matches', 'progress', 'evaluationCounts'] }).unwrap()
        if (!execution) {
          return
        }
        dispatch(setCrossClientResultsExecution(execution))
      } catch (e) {
        console.error(e)
      } finally {
        dispatch(setCrossClientResultsExecutionLoading(false))
      }
    }
    getExecution()
  }, [dispatch, accountId, executionId, triggerGetCrossClientQueryExecution])

  useEffect(() => {
    const getCrossClientTeammates = async () => {
      const teammates = await triggerGetAllUsers({ accountId, identityTypes: ['idp'] }).unwrap()
      if (teammates?.data) {
        dispatch(setCrossClientTeammates(teammates.data))
      }
    }
    getCrossClientTeammates().catch(console.error)
  }, [dispatch, accountId, triggerGetAllUsers])

  useEffect(() => {
    return () => {
      dispatch(resetCrossClientResults())
    }
  }, [dispatch])

  return null
}
